import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'conversation-close-warning',
	templateUrl: './conversation-close-warning.component.html',
	styleUrls: ['./conversation-close-warning.component.scss'],
	standalone: false
})
export class ConversationCloseWarningComponent implements OnInit {
	public accountIdToRemove: number;

	constructor(public dialogRef: MatDialogRef<ConversationCloseWarningComponent>) {}

	ngOnInit() {}

	public reallyClose() {
		this.dialogRef.close(true);
	}
}
